import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { Paper } from '@material-ui/core'
import _ from 'lodash'
import moment from 'moment'

import agent from 'agent'
import educationLevels from 'assets/education-level.json'
import { UPDATE_USER, UPDATE_PARENT } from 'constants/actionTypes'
import { validateTextEntry, validatePassword } from 'utils/formValidation'
import StepperProfile from 'components/nav/app/profile/profile-progress'
import schoolType from 'assets/type-of-school.json'
import schools from 'assets/schools.json'

const mapStateToProps = state => ({
  currentUser: state.common.currentUser,
  updateUserInProgress: state.common.updateUserInProgress
})

const mapDispatchToProps = dispatch => ({
  updateUser: user => dispatch({ type: UPDATE_USER, payload: agent.Auth.updateUser(user), user }),
  updateParentMeta: (parent, userObj) =>
    dispatch({ type: UPDATE_PARENT, payload: agent.Auth.updateParentMeta(parent, userObj) })
})

class Edit extends React.Component {
  state = {
    email: '',
    name: '',
    dateOfBirth: '',
    gender: '',
    phoneCountryCode: 65,
    phone: '',
    level: '',
    othersLevel: '',
    showOthersLevel: false,
    school: '',
    othersSchool: '',
    showOthersSchool: false,

    useStudentPhone: false,
    useStudentEmail: false,
    contactPreference: 'nil',
    contactPreferenceOther: '',
    facebook: '',
    line: '',
    formError: {},
    isSaved: false,

    studyMediumEng: false,
    studyMediumThai: false,

    studyingAtOtherSchool: 'nil',
    studyingAtOtherSchoolName: '',

    gpaEngBox: true,
    gpaThaiBox: true,
    gpaMathsBox: true,
    gpaPhysBox: true,
    gpaChemBox: true,
    gpaBioBox: true,
    gpaGeoBox: true, //geography
    gpaHistBox: true,
    gpaLitBox: true, //literature
    gpaSSBox: true, //social studies
    gpaPolBox: true, //politics
    gpaEcoBox: true, //economics
    gpaArtBox: true,
    gpaFLBox: true, //foreign languageg,
    gpaOthersBox: true,

    gpaEng: '',
    gpaThai: '',
    gpaMaths: '',
    gpaPhys: '',
    gpaChem: '',
    gpaBio: '',
    gpaGeo: '',
    gpaHist: '',
    gpaLit: '',
    gpaSS: '',
    gpaPol: '',
    gpaEco: '',
    gpaArt: '',
    gpaFL: '',
    gpaOthersField: '',

    favSubjEngBox: false,
    favSubjThaiBox: false,
    favSubjMathsBox: false,
    favSubjPhysBox: false,
    favSubjChemBox: false,
    favSubjBioBox: false,
    favSubjGeoBox: false, //geography
    favSubjHistBox: false,
    favSubjLitBox: false, //literature
    favSubjSSBox: false, //social studies
    favSubjPolBox: false, //politics
    favSubjEcoBox: false, //economics
    favSubjArtBox: false,
    favSubjFLBox: false, //foreign language
    favSubjOthersBox: false,
    favSubjOthersBoxField: '',

    weakestSubjEngBox: false,
    weakestSubjThaiBox: false,
    weakestSubjMathsBox: false,
    weakestSubjPhysBox: false,
    weakestSubjChemBox: false,
    weakestSubjBioBox: false,
    weakestSubjGeoBox: false, //geography
    weakestSubjHistBox: false,
    weakestSubjLitBox: false, //literature
    weakestSubjSSBox: false, //social studies
    weakestSubjPolBox: false, //politics
    weakestSubjEcoBox: false, //economics
    weakestSubjArtBox: false,
    weakestSubjFLBox: false, //foreign language
    weakestSubjOthersBox: false,
    weakestSubjOthersBoxField: '',

    extExamSAT: false,
    extExamGRE: false,
    extExamIELTS: false,
    extExamTOEFL: false,
    extExamGMAT: false,
    extExamOthers: false,
    extExamOthersField: '',

    otherTCcourseSAT: false,
    otherTCcourseGRE: false,
    otherTCcourseIELTS: false,
    otherTCcourseTOEFL: false,
    otherTCcourseGMAT: false,
    otherTCcourseEnglish: false,
    otherTCcourseThai: false,
    otherTCcourseMath: false,
    otherTCcoursePhysics: false,
    otherTCcourseBiology: false,
    otherTCcourseGeography: false,
    otherTCcourseChemistry: false,
    otherTCcourseHistory: false,
    otherTCcourseLiterature: false,
    otherTCcourseSocialStudies: false,
    otherTCcoursePolitics: false,
    otherTCcourseEconomics: false,
    otherTCcourseArt: false,
    otherTCcourseForeignLanguage: false,
    otherTCcourseOthers: false,
    otherTCcourseOthersField: '',

    studyingAtEPA: 'nil',
    coursesTakenAtEpaSAT: false,
    coursesTakenAtEpaGRE: false,
    coursesTakenAtEpaIELTS: false,
    coursesTakenAtEpaTOEFL: false,
    coursesTakenAtEpaGMAT: false,
    coursesTakenAtEpaEnglish: false,
    coursesTakenAtEpaThai: false,
    coursesTakenAtEpaMath: false,
    coursesTakenAtEpaPhysics: false,
    coursesTakenAtEpaBiology: false,
    coursesTakenAtEpaGeography: false,
    coursesTakenAtEpaChemistry: false,
    coursesTakenAtEpaHistory: false,
    coursesTakenAtEpaLiterature: false,
    coursesTakenAtEpaSocialStudies: false,
    coursesTakenAtEpaPolitics: false,
    coursesTakenAtEpaEconomics: false,
    coursesTakenAtEpaArt: false,
    coursesTakenAtEpaForeignLanguage: false,
    coursesTakenAtEpaOthers: false,
    coursesTakenAtEpaOthersField: '',

    needConsultationForACC: false,
    careerGoalsStudentPerspective: '',
    careerGoalsParentPerspective: '',

    studyGoalsStudentPerspectiveEntranceExamBox: false,
    studyGoalsStudentPerspectiveEntranceExamField: '',
    studyGoalsStudentPerspectiveSchoolExamBox: false,
    studyGoalsStudentPerspectiveSATBox: false,
    studyGoalsStudentPerspectiveGREBox: false,
    studyGoalsStudentPerspectiveIELTSBox: false,
    studyGoalsStudentPerspectiveTOEFLBox: false,
    studyGoalsStudentPerspectiveGMATBox: false,
    studyGoalsStudentPerspectiveOthersBox: false,
    studyGoalsStudentPerspectiveOthersField: '',

    studyGoalsParentPerspectiveEntranceExamBox: false,
    studyGoalsParentPerspectiveEntranceExamField: '',
    studyGoalsParentPerspectiveSchoolExamBox: false,
    studyGoalsParentPerspectiveSATBox: false,
    studyGoalsParentPerspectiveGREBox: false,
    studyGoalsParentPerspectiveIELTSBox: false,
    studyGoalsParentPerspectiveTOEFLBox: false,
    studyGoalsParentPerspectiveGMATBox: false,
    studyGoalsParentPerspectiveOthersBox: false,
    studyGoalsParentPerspectiveOthersField: '',

    targetCountryStudentUS: false,
    targetCountryStudentCanada: false,
    targetCountryStudentUK: false,
    targetCountryStudentAustralia: false,
    targetCountryStudentNewZealand: false,
    targetCountryStudentOthersBox: false,
    targetCountryStudentOthersField: '',

    targetCountryParentUS: false,
    targetCountryParentCanada: false,
    targetCountryParentUK: false,
    targetCountryParentAustralia: false,
    targetCountryParentNewZealand: false,
    targetCountryParentOthersBox: false,
    targetCountryParentOthersField: '',

    areaOfStudy: '',
    areaOfStudySpecific: '',
    areaOfStudy1: '',
    areaOfStudySpecific1: '',
    areaOfStudy2: '',
    areaOfStudySpecific2: '',
    areaOfStudy3: '',
    areaOfStudySpecific3: '',
    areaOfStudy4: '',
    areaOfStudySpecific4: '',
    areaOfStudyOthers: false,
    areaOfStudyOthersField: '',
    areaOfStudyUnsure: false,

    areaOfStudyParent: '',
    areaOfStudyParentSpecific: '',
    areaOfStudyParent1: '',
    areaOfStudyParentSpecific1: '',
    areaOfStudyParent2: '',
    areaOfStudyParentSpecific2: '',
    areaOfStudyParent3: '',
    areaOfStudyParentSpecific3: '',
    areaOfStudyParent4: '',
    areaOfStudyParentSpecific4: '',
    areaOfStudyParentOthers: false,
    areaOfStudyParentOthersField: '',
    areaOfStudyParentUnsure: false,

    specialRequests: '',

    learningTypeVisual: false,
    learningTypeKinaesthetic: false,
    learningTypeAural: false,
    learningTypeSocial: false,
    learningTypeSolitary: false,
    learningTypeVerbal: false,
    learningTypeLogical: false,
    learningTypeUnsure: false,
    learningTypeOthersBox: false,
    learningTypeOthersField: '',

    personalityTestCheck: 'nil',
    personalityTestResult: '',
    personalityTestResultField: '',

    scDominanceDirect: false,
    scDominanceResultsOriented: false,
    scDominanceFirm: false,
    scDominanceStrongWilled: false,
    scDominanceForceful: false,

    scInfluenceOutgoing: false,
    scInfluenceEnthusiastic: false,
    scInfluenceOptimistic: false,
    scInfluenceHighSpirited: false,
    scInfluenceLively: false,
    scConscientiousnessAnalytical: false,
    scConscientiousnessReserved: false,
    scConscientiousnessPrecise: false,
    scConscientiousnessPrivate: false,
    scConscientiousnessSystematic: false,
    scSteadinessEvenTempered: false,
    scSteadinessAccommodating: false,
    scSteadinessPatient: false,
    scSteadinessHumble: false,
    scSteadinessTactful: false,

    healthConditionNA: false,
    healthConditionADHD: false,
    healthConditionAutism: false,
    healthConditionOthersBox: false,
    healthConditionOthersField: '',

    preferredTeacherStudentPerspectiveMale: false,
    preferredTeacherStudentPerspectiveFemale: false,
    preferredTeacherStudentPerspectiveNameBox: false,
    preferredTeacherStudentPerspectiveNameField: '',
    preferredTeacherStudentPerspectiveAuthority: false,
    preferredTeacherStudentPerspectiveDelegator: false,
    preferredTeacherStudentPerspectiveFacilitator: false,
    preferredTeacherStudentPerspectiveDemonstrator: false,
    preferredTeacherStudentPerspectiveHybrid: false,
    preferredTeacherStudentPerspectiveOthersBox: false,
    preferredTeacherStudentPerspectiveOthersField: '',

    preferredTeacherParentPerspectiveMale: false,
    preferredTeacherParentPerspectiveFemale: false,
    preferredTeacherParentPerspectiveNameBox: false,
    preferredTeacherParentPerspectiveNameField: '',
    preferredTeacherParentPerspectiveAuthority: false,
    preferredTeacherParentPerspectiveDelegator: false,
    preferredTeacherParentPerspectiveFacilitator: false,
    preferredTeacherParentPerspectiveDemonstrator: false,
    preferredTeacherParentPerspectiveHybrid: false,
    preferredTeacherParentPerspectiveOthersBox: false,
    preferredTeacherParentPerspectiveOthersField: '',

    interestedTopicsPublicSpeaking: false,
    interestedTopicsDebate: false,
    interestedTopicsCoding: false,
    interestedTopicsLeadership: false,
    interestedTopicsWriting: false,
    interestedTopicsCreativeWriting: false,
    interestedTopicsFormalWriting: false,
    interestedTopicsReadingComprehension: false,
    interestedTopicsLiterature: false,
    interestedTopicsOthersBox: false,
    interestedTopicsOthersField: '',

    parentGender: '',
    parentDOB: '',
    parentSalute: '',
    parentName: '',
    parentEmail: '',
    parentPhoneCountryCode: '',
    parentPhone: '',

    parentContactPreference: 'nil',
    parentContactPreferenceOther: '',
    parentFacebook: '',
    parentLine: '',

    parentOccupation: '',
    parentOccupationSpecific: '',
    parentFamilyBackground: '',
    parentNetworkingFB: false,
    parentNetworkingWebsite: false,
    parentNetworkingFriends: false,
    parentNetworkingOthersBox: false,
    parentNetworkingOthersField: '',

    pcDominanceDirect: false,
    pcDominanceResultsOriented: false,
    pcDominanceFirm: false,
    pcDominanceStrongWilled: false,
    pcDominanceForceful: false,
    pcInfluenceOutgoing: false,
    pcInfluenceEnthusiastic: false,
    pcInfluenceOptimistic: false,
    pcInfluenceHighSpirited: false,
    pcInfluenceLively: false,
    pcConscientiousnessAnalytical: false,
    pcConscientiousnessReserved: false,
    pcConscientiousnessPrecise: false,
    pcConscientiousnessPrivate: false,
    pcConscientiousnessSystematic: false,
    pcSteadinessEvenTempered: false,
    pcSteadinessAccommodating: false,
    pcSteadinessPatient: false,
    pcSteadinessHumble: false,
    pcSteadinessTactful: false,
    parentConflict: false,
    parentDecisionFather: false,
    parentDecisionMother: false,

    paymentMode: 'nil',
    parentInterestedTopicsPublicSpeaking: false,
    parentInterestedTopicsDebate: false,
    parentInterestedTopicsCoding: false,
    parentInterestedTopicsLeadership: false,
    parentInterestedTopicsWriting: false,
    parentInterestedTopicsCreativeWriting: false,
    parentInterestedTopicsFormalWriting: false,
    parentInterestedTopicsReadingComprehension: false,
    parentInterestedTopicsLiterature: false,
    parentInterestedTopicsOthersBox: false,
    parentInterestedTopicsOthersField: '',
    parentDateOfRenewal: ''
  }

  componentDidMount() {
    const { currentUser } = this.props
    const { parent } = currentUser

    let displayLevel = '',
      showOthersLevel = false,
      othersLevel = '',
      displaySchool = '',
      showOthersSchool = false,
      othersSchool = '',
      displayOtherTypeOfSchool = '',
      showOthersTypeOfSchool = false,
      othersTypeOfSchool = ''

    if (currentUser.level) {
      let levelObj = _.find(educationLevels, function (o) {
        return o.code === currentUser.level
      })
      if (levelObj) {
        displayLevel = levelObj.code
      } else {
        showOthersLevel = true
        othersLevel = currentUser.level
        displayLevel = 'others'
      }
    }

    if (currentUser.school) {
      let schoolObj = _.find(schools, function (o) {
        return o.name === currentUser.school
      })
      if (schoolObj) {
        displaySchool = schoolObj.name
      } else {
        showOthersSchool = true
        othersSchool = currentUser.school
        displaySchool = 'others'
      }
    }

    if (currentUser.typeOfSchool) {
      let schoolTypeObj = _.find(schoolType, function (o) {
        return o.code === currentUser.typeOfSchool
      })
      if (schoolTypeObj) {
        displayOtherTypeOfSchool = schoolTypeObj.code
      } else {
        showOthersTypeOfSchool = true
        othersTypeOfSchool = currentUser.typeOfSchool
        displayOtherTypeOfSchool = 'others'
      }
    }

    let parentPhoneCountryCode = 65
    if (parent?.phone_country_code) {
      parentPhoneCountryCode = parent.phone_country_code
    } else {
      parentPhoneCountryCode = currentUser.phone_country_code
    }

    this.setState({
      email: currentUser.email,
      name: currentUser.name ?? '',
      dateOfBirth: currentUser.date_of_birth
        ? moment(currentUser.date_of_birth).startOf('day').format('YYYY-MM-DD')
        : '',
      gender: currentUser.gender ?? '',
      phoneCountryCode: currentUser.phone_country_code,
      phone: currentUser.phone ?? '',
      level: displayLevel,
      othersLevel,
      showOthersLevel,
      // school: currentUser.school ?? '',
      school: displaySchool,
      othersSchool,
      showOthersSchool,
      typeOfSchool: displayOtherTypeOfSchool,
      othersTypeOfSchool,
      showOthersTypeOfSchool,
      firstLanguage: currentUser.first_language ?? '',

      contactPreference: currentUser.contact_preference?.contact ?? 'nil',
      contactPreferenceOther: currentUser.contact_preference?.others_type ?? '',
      facebook: currentUser.facebook ?? '',
      line: currentUser.line ?? '',

      gradeLevel: currentUser.gradeYearLevel?.grade ?? '',
      yearLevel: currentUser.gradeYearLevel?.year ?? '',

      studyMediumEng: currentUser.studyMediumEng ? true : false,
      studyMediumThai: currentUser.studyMediumThai ? true : false,

      studyingAtOtherSchool: currentUser.studyingAtOtherSchool?.at_other_school ?? 'nil',
      studyingAtOtherSchoolName: currentUser.studyingAtOtherSchool?.at_other_school_name ?? '',

      gpaEngBox: currentUser.grade?.english ? true : false,
      gpaThaiBox: currentUser.grade?.thai ? true : false,
      gpaMathsBox: currentUser.grade?.math ? true : false,
      gpaPhysBox: currentUser.grade?.physics ? true : false,
      gpaChemBox: currentUser.grade?.chemistry ? true : false,
      gpaBioBox: currentUser.grade?.biology ? true : false,
      gpaGeoBox: currentUser.grade?.geography ? true : false, //geography
      gpaHistBox: currentUser.grade?.history ? true : false,
      gpaLitBox: currentUser.grade?.literature ? true : false, //literature
      gpaSSBox: currentUser.grade?.social_studies ? true : false, //social studies
      gpaPolBox: currentUser.grade?.politics ? true : false, //politics
      gpaEcoBox: currentUser.grade?.economics ? true : false, //economics
      gpaArtBox: currentUser.grade?.art ? true : false,
      gpaFLBox: currentUser.grade?.foreign_language ? true : false, //foreign language
      gpaOthersBox: currentUser.grade?.others ? true : false,

      gpaEng: currentUser.grade?.gpa?.english ?? '',
      gpaThai: currentUser.grade?.gpa?.thai ?? '',
      gpaMaths: currentUser.grade?.gpa?.math ?? '',
      gpaPhys: currentUser.grade?.gpa?.physics ?? '',
      gpaChem: currentUser.grade?.gpa?.chemistry ?? '',
      gpaBio: currentUser.grade?.gpa?.biology ?? '',
      gpaGeo: currentUser.grade?.gpa?.geography ?? '',
      gpaHist: currentUser.grade?.gpa?.history ?? '',
      gpaLit: currentUser.grade?.gpa?.literature ?? '',
      gpaSS: currentUser.grade?.gpa?.social_studies ?? '',
      gpaPol: currentUser.grade?.gpa?.politics ?? '',
      gpaEco: currentUser.grade?.gpa?.economics ?? '',
      gpaArt: currentUser.grade?.gpa?.art ?? '',
      gpaFL: currentUser.grade?.gpa?.foreign_language ?? '',
      gpaOthersField: currentUser.grade?.gpa?.others_type ?? '',

      favSubjEngBox: currentUser.favoriteSubjects?.english ? true : false,
      favSubjThaiBox: currentUser.favoriteSubjects?.thai ? true : false,
      favSubjMathsBox: currentUser.favoriteSubjects?.math ? true : false,
      favSubjPhysBox: currentUser.favoriteSubjects?.physics ? true : false,
      favSubjChemBox: currentUser.favoriteSubjects?.chemistry ? true : false,
      favSubjBioBox: currentUser.favoriteSubjects?.biology ? true : false,
      favSubjGeoBox: currentUser.favoriteSubjects?.geography ? true : false,
      favSubjHistBox: currentUser.favoriteSubjects?.history ? true : false,
      favSubjLitBox: currentUser.favoriteSubjects?.literature ? true : false,
      favSubjSSBox: currentUser.favoriteSubjects?.social_studies ? true : false,
      favSubjPolBox: currentUser.favoriteSubjects?.politics ? true : false,
      favSubjEcoBox: currentUser.favoriteSubjects?.economics ? true : false,
      favSubjArtBox: currentUser.favoriteSubjects?.art ? true : false,
      favSubjFLBox: currentUser.favoriteSubjects?.foreign_language ? true : false,
      favSubjOthersBox: currentUser.favoriteSubjects?.others ? true : false,
      favSubjOthersBoxField: currentUser.favoriteSubjects?.others_type ?? '',

      weakestSubjEngBox: currentUser.weakestSubjects?.english ? true : false,
      weakestSubjThaiBox: currentUser.weakestSubjects?.thai ? true : false,
      weakestSubjMathsBox: currentUser.weakestSubjects?.math ? true : false,
      weakestSubjPhysBox: currentUser.weakestSubjects?.physics ? true : false,
      weakestSubjChemBox: currentUser.weakestSubjects?.chemistry ? true : false,
      weakestSubjBioBox: currentUser.weakestSubjects?.biology ? true : false,
      weakestSubjGeoBox: currentUser.weakestSubjects?.geography ? true : false, //geography
      weakestSubjHistBox: currentUser.weakestSubjects?.history ? true : false,
      weakestSubjLitBox: currentUser.weakestSubjects?.literature ? true : false, //literature
      weakestSubjSSBox: currentUser.weakestSubjects?.social_studies ? true : false, //social studies
      weakestSubjPolBox: currentUser.weakestSubjects?.politics ? true : false, //politics
      weakestSubjEcoBox: currentUser.weakestSubjects?.economics ? true : false, //economics
      weakestSubjArtBox: currentUser.weakestSubjects?.art ? true : false,
      weakestSubjFLBox: currentUser.weakestSubjects?.foreign_language ? true : false, //foreign language
      weakestSubjOthersBox: currentUser.weakestSubjects?.others ? true : false,
      weakestSubjOthersBoxField: currentUser.weakestSubjects?.others_type ?? '',

      extExamSAT: currentUser.externalExams?.sat ? true : false,
      extExamGRE: currentUser.externalExams?.gre ? true : false,
      extExamIELTS: currentUser.externalExams?.ielts ? true : false,
      extExamTOEFL: currentUser.externalExams?.toefl ? true : false,
      extExamGMAT: currentUser.externalExams?.gmat ? true : false,
      extExamOthers: currentUser.externalExams?.others ? true : false,
      extExamOthersField: currentUser.externalExams?.others_type ?? '',

      otherTCcourseSAT: currentUser.coursesTuition?.sat ? true : false,
      otherTCcourseGRE: currentUser.coursesTuition?.gre ? true : false,
      otherTCcourseIELTS: currentUser.coursesTuition?.ielts ? true : false,
      otherTCcourseTOEFL: currentUser.coursesTuition?.toefl ? true : false,
      otherTCcourseGMAT: currentUser.coursesTuition?.gmat ? true : false,
      otherTCcourseEnglish: currentUser.coursesTuition?.english ? true : false,
      otherTCcourseThai: currentUser.coursesTuition?.thai ? true : false,
      otherTCcourseMath: currentUser.coursesTuition?.math ? true : false,
      otherTCcoursePhysics: currentUser.coursesTuition?.physics ? true : false,
      otherTCcourseBiology: currentUser.coursesTuition?.biology ? true : false,
      otherTCcourseGeography: currentUser.coursesTuition?.geography ? true : false,
      otherTCcourseChemistry: currentUser.coursesTuition?.chemistry ? true : false,
      otherTCcourseHistory: currentUser.coursesTuition?.history ? true : false,
      otherTCcourseLiterature: currentUser.coursesTuition?.literature ? true : false,
      otherTCcourseSocialStudies: currentUser.coursesTuition?.social_studies ? true : false,
      otherTCcoursePolitics: currentUser.coursesTuition?.politics ? true : false,
      otherTCcourseEconomics: currentUser.coursesTuition?.economics ? true : false,
      otherTCcourseArt: currentUser.coursesTuition?.art ? true : false,
      otherTCcourseForeignLanguage: currentUser.coursesTuition?.foreign_language ? true : false,
      otherTCcourseOthers: currentUser.coursesTuition?.others ? true : false,
      otherTCcourseOthersField: currentUser.coursesTuition?.others_type ?? '',

      studyingAtEPA: currentUser.currentlyAtEPA?.studyingAtEPA ?? 'n',
      coursesTakenAtEpaSAT: currentUser.currentlyAtEPA?.coursesTakenAtEPA?.sat ? true : false,
      coursesTakenAtEpaGRE: currentUser.currentlyAtEPA?.coursesTakenAtEPA?.gre ? true : false,
      coursesTakenAtEpaIELTS: currentUser.currentlyAtEPA?.coursesTakenAtEPA?.ielts ? true : false,
      coursesTakenAtEpaTOEFL: currentUser.currentlyAtEPA?.coursesTakenAtEPA?.toefl ? true : false,
      coursesTakenAtEpaGMAT: currentUser.currentlyAtEPA?.coursesTakenAtEPA?.gmat ? true : false,
      coursesTakenAtEpaEnglish: currentUser.currentlyAtEPA?.coursesTakenAtEPA?.english ? true : false,
      coursesTakenAtEpaThai: currentUser.currentlyAtEPA?.coursesTakenAtEPA?.thai ? true : false,
      coursesTakenAtEpaMath: currentUser.currentlyAtEPA?.coursesTakenAtEPA?.math ? true : false,
      coursesTakenAtEpaPhysics: currentUser.currentlyAtEPA?.coursesTakenAtEPA?.physics ? true : false,
      coursesTakenAtEpaBiology: currentUser.currentlyAtEPA?.coursesTakenAtEPA?.biology ? true : false,
      coursesTakenAtEpaGeography: currentUser.currentlyAtEPA?.coursesTakenAtEPA?.geography ? true : false,
      coursesTakenAtEpaChemistry: currentUser.currentlyAtEPA?.coursesTakenAtEPA?.chemistry ? true : false,
      coursesTakenAtEpaHistory: currentUser.currentlyAtEPA?.coursesTakenAtEPA?.history ? true : false,
      coursesTakenAtEpaLiterature: currentUser.currentlyAtEPA?.coursesTakenAtEPA?.literature ? true : false,
      coursesTakenAtEpaSocialStudies: currentUser.currentlyAtEPA?.coursesTakenAtEPA?.social_studies ? true : false,
      coursesTakenAtEpaPolitics: currentUser.currentlyAtEPA?.coursesTakenAtEPA?.politics ? true : false,
      coursesTakenAtEpaEconomics: currentUser.currentlyAtEPA?.coursesTakenAtEPA?.economics ? true : false,
      coursesTakenAtEpaArt: currentUser.currentlyAtEPA?.coursesTakenAtEPA?.art ? true : false,
      coursesTakenAtEpaForeignLanguage: currentUser.currentlyAtEPA?.coursesTakenAtEPA?.foreign_language ? true : false,
      coursesTakenAtEpaOthers: currentUser.currentlyAtEPA?.coursesTakenAtEPA?.others ? true : false,
      coursesTakenAtEpaOthersField: currentUser.currentlyAtEPA?.coursesTakenAtEPA?.others_type ?? '',

      needConsultationForACC: currentUser.careerGoals?.consultation ?? false,
      careerGoalsStudentPerspective: currentUser.careerGoals?.student ?? '',
      careerGoalsParentPerspective: currentUser.careerGoals?.parent ?? '',

      studyGoalsStudentPerspectiveEntranceExamBox: currentUser.studyGoals?.student?.entrance ?? false,
      studyGoalsStudentPerspectiveEntranceExamField: currentUser.studyGoals?.student?.entrance_type ?? '',
      studyGoalsStudentPerspectiveSchoolExamBox: currentUser.studyGoals?.student?.school_exam ?? false,
      studyGoalsStudentPerspectiveSATBox: currentUser.studyGoals?.student?.sat ?? false,
      studyGoalsStudentPerspectiveGREBox: currentUser.studyGoals?.student?.gre ?? false,
      studyGoalsStudentPerspectiveIELTSBox: currentUser.studyGoals?.student?.ielts ?? false,
      studyGoalsStudentPerspectiveTOEFLBox: currentUser.studyGoals?.student?.toefl ?? false,
      studyGoalsStudentPerspectiveGMATBox: currentUser.studyGoals?.student?.gmat ?? false,
      studyGoalsStudentPerspectiveOthersBox: currentUser.studyGoals?.student?.others ?? false,
      studyGoalsStudentPerspectiveOthersField: currentUser.studyGoals?.student?.others_type ?? '',

      studyGoalsParentPerspectiveEntranceExamBox: currentUser?.studyGoals?.parent?.entrance ?? false,
      studyGoalsParentPerspectiveEntranceExamField: currentUser.studyGoals?.parent?.entrance_type ?? '',
      studyGoalsParentPerspectiveSchoolExamBox: currentUser.studyGoals?.parent?.school_exam ?? false,
      studyGoalsParentPerspectiveSATBox: currentUser.studyGoals?.parent?.sat ?? false,
      studyGoalsParentPerspectiveGREBox: currentUser.studyGoals?.parent?.gre ?? false,
      studyGoalsParentPerspectiveIELTSBox: currentUser.studyGoals?.parent?.ielts ?? false,
      studyGoalsParentPerspectiveTOEFLBox: currentUser.studyGoals?.parent?.toefl ?? false,
      studyGoalsParentPerspectiveGMATBox: currentUser.studyGoals?.parent?.gmat ?? false,
      studyGoalsParentPerspectiveOthersBox: currentUser.studyGoals?.parent?.others ?? false,
      studyGoalsParentPerspectiveOthersField: currentUser.studyGoals?.parent?.others_type ?? '',

      targetCountryStudentUS: currentUser.targetCountry?.student?.us ?? false,
      targetCountryStudentCanada: currentUser.targetCountry?.student?.canada ?? false,
      targetCountryStudentUK: currentUser.targetCountry?.student?.uk ?? false,
      targetCountryStudentAustralia: currentUser.targetCountry?.student?.aus ?? false,
      targetCountryStudentNewZealand: currentUser.targetCountry?.student?.nz ?? false,
      targetCountryStudentOthersBox: currentUser.targetCountry?.student?.others ?? false,
      targetCountryStudentOthersField: currentUser.targetCountry?.student?.others_type ?? '',

      targetCountryParentUS: currentUser.targetCountry?.parent?.us ?? false,
      targetCountryParentCanada: currentUser.targetCountry?.parent?.canada ?? false,
      targetCountryParentUK: currentUser.targetCountry?.parent?.uk ?? false,
      targetCountryParentAustralia: currentUser.targetCountry?.parent?.aus ?? false,
      targetCountryParentNewZealand: currentUser.targetCountry?.parent?.nz ?? false,
      targetCountryParentOthersBox: currentUser.targetCountry?.parent?.others ?? false,
      targetCountryParentOthersField: currentUser.targetCountry?.parent?.others_type ?? '',

      areaOfStudy: currentUser.areaOfStudy?.area ?? '',
      areaOfStudySpecific: currentUser.areaOfStudy?.specific ?? '',
      areaOfStudy1: currentUser.areaOfStudy?.area1 ?? '',
      areaOfStudySpecific1: currentUser.areaOfStudy?.specific1 ?? '',
      areaOfStudy2: currentUser.areaOfStudy?.area2 ?? '',
      areaOfStudySpecific2: currentUser.areaOfStudy?.specific2 ?? '',
      areaOfStudy3: currentUser.areaOfStudy?.area3 ?? '',
      areaOfStudySpecific3: currentUser.areaOfStudy?.specific3 ?? '',
      areaOfStudy4: currentUser.areaOfStudy?.area4 ?? '',
      areaOfStudySpecific4: currentUser.areaOfStudy?.specific4 ?? '',
      areaOfStudyOthers: currentUser.areaOfStudy?.others ?? false,
      areaOfStudyOthersField: currentUser.areaOfStudy?.others_type ?? '',
      areaOfStudyUnsure: currentUser.areaOfStudy?.unsure ?? false,

      areaOfStudyParent: currentUser.areaOfStudy?.parent?.area ?? '',
      areaOfStudyParentSpecific: currentUser.areaOfStudy?.parent?.specific ?? '',
      areaOfStudyParent1: currentUser.areaOfStudy?.parent?.area1 ?? '',
      areaOfStudyParentSpecific1: currentUser.areaOfStudy?.parent?.specific1 ?? '',
      areaOfStudyParent2: currentUser.areaOfStudy?.parent?.area2 ?? '',
      areaOfStudyParentSpecific2: currentUser.areaOfStudy?.parent?.specific2 ?? '',
      areaOfStudyParent3: currentUser.areaOfStudy?.parent?.area3 ?? '',
      areaOfStudyParentSpecific3: currentUser.areaOfStudy?.parent?.specific3 ?? '',
      areaOfStudyParent4: currentUser.areaOfStudy?.parent?.area4 ?? '',
      areaOfStudyParentSpecific4: currentUser.areaOfStudy?.parent?.specific4 ?? '',
      areaOfStudyParentOthers: currentUser.areaOfStudy?.parent?.others ?? false,
      areaOfStudyParentOthersField: currentUser.areaOfStudy?.parent?.others_type ?? false,
      areaOfStudyParentUnsure: currentUser.areaOfStudy?.parent?.unsure ?? false,

      specialRequests: currentUser.specialRequests ?? '',

      learningTypeVisual: currentUser.learningType?.visual ?? false,
      learningTypeKinaesthetic: currentUser.learningType?.kinaesthetic ?? false,
      learningTypeAural: currentUser.learningType?.aural ?? false,
      learningTypeSocial: currentUser.learningType?.social ?? false,
      learningTypeSolitary: currentUser.learningType?.solitary ?? false,
      learningTypeVerbal: currentUser.learningType?.verbal ?? false,
      learningTypeLogical: currentUser.learningType?.logical ?? false,
      learningTypeUnsure: currentUser.learningType?.unsure ?? false,
      learningTypeOthersBox: currentUser.learningType?.others ?? false,
      learningTypeOthersField: currentUser.learningType?.others_type ?? '',

      personalityTestCheck: currentUser.personalityTest?.attempted ?? 'nil',
      personalityTestResult: currentUser.personalityTest?.result ?? '',
      personalityTestResultField: currentUser.personalityTest?.result_field ?? '',

      scDominanceDirect: currentUser.studentCharacter?.dominance?.direct ?? false,
      scDominanceResultsOriented: currentUser.studentCharacter?.dominance?.result_oriented ?? false,
      scDominanceFirm: currentUser.studentCharacter?.dominance?.firm ?? false,
      scDominanceStrongWilled: currentUser.studentCharacter?.dominance?.strong_willed ?? false,
      scDominanceForceful: currentUser.studentCharacter?.dominance?.forceful ?? false,
      scInfluenceOutgoing: currentUser.studentCharacter?.influence?.outgoing ?? false,
      scInfluenceEnthusiastic: currentUser.studentCharacter?.influence?.enthusiastic ?? false,
      scInfluenceOptimistic: currentUser.studentCharacter?.influence?.optimistic ?? false,
      scInfluenceHighSpirited: currentUser.studentCharacter?.influence?.high_spirited ?? false,
      scInfluenceLively: currentUser.studentCharacter?.influence?.lively ?? false,
      scConscientiousnessAnalytical: currentUser.studentCharacter?.conscientiousness?.analytical ?? false,
      scConscientiousnessReserved: currentUser.studentCharacter?.conscientiousness?.reserved ?? false,
      scConscientiousnessPrecise: currentUser.studentCharacter?.conscientiousness?.precise ?? false,
      scConscientiousnessPrivate: currentUser.studentCharacter?.conscientiousness?.private ?? false,
      scConscientiousnessSystematic: currentUser.studentCharacter?.conscientiousness?.systematic ?? false,
      scSteadinessEvenTempered: currentUser.studentCharacter?.steadiness?.even_tempered ?? false,
      scSteadinessAccommodating: currentUser.studentCharacter?.steadiness?.accommodating ?? false,
      scSteadinessPatient: currentUser.studentCharacter?.steadiness?.patient ?? false,
      scSteadinessHumble: currentUser.studentCharacter?.steadiness?.humble ?? false,
      scSteadinessTactful: currentUser.studentCharacter?.steadiness?.tactful ?? false,

      healthConditionNA: currentUser.healthCondition?.na ?? false,
      healthConditionADHD: currentUser.healthCondition?.adhd ?? false,
      healthConditionAutism: currentUser.healthCondition?.autism ?? false,
      healthConditionOthersBox: currentUser.healthCondition?.others ?? false,
      healthConditionOthersField: currentUser.healthCondition?.others_type ?? '',

      preferredTeacherStudentPerspectiveMale: currentUser.preferredTeacher?.student?.male ?? false,
      preferredTeacherStudentPerspectiveFemale: currentUser.preferredTeacher?.student?.female ?? false,
      preferredTeacherStudentPerspectiveNameBox: currentUser.preferredTeacher?.student?.name ?? false,
      preferredTeacherStudentPerspectiveNameField: currentUser.preferredTeacher?.student?.name_type ?? '',
      preferredTeacherStudentPerspectiveAuthority: currentUser.preferredTeacher?.student?.authority ?? false,
      preferredTeacherStudentPerspectiveDelegator: currentUser.preferredTeacher?.student?.delegator ?? false,
      preferredTeacherStudentPerspectiveFacilitator: currentUser.preferredTeacher?.student?.facilitator ?? false,
      preferredTeacherStudentPerspectiveDemonstrator: currentUser.preferredTeacher?.student?.demonstrator ?? false,
      preferredTeacherStudentPerspectiveHybrid: currentUser.preferredTeacher?.student?.hybrid ?? false,
      preferredTeacherStudentPerspectiveOthersBox: currentUser.preferredTeacher?.student?.others ?? false,
      preferredTeacherStudentPerspectiveOthersField: currentUser.preferredTeacher?.student?.others_type ?? '',

      preferredTeacherParentPerspectiveMale: currentUser.preferredTeacher?.parent?.male ?? false,
      preferredTeacherParentPerspectiveFemale: currentUser.preferredTeacher?.parent?.female ?? false,
      preferredTeacherParentPerspectiveNameBox: currentUser.preferredTeacher?.parent?.name ?? false,
      preferredTeacherParentPerspectiveNameField: currentUser.preferredTeacher?.parent?.name_type ?? '',
      preferredTeacherParentPerspectiveAuthority: currentUser.preferredTeacher?.parent?.authority ?? false,
      preferredTeacherParentPerspectiveDelegator: currentUser.preferredTeacher?.parent?.delegator ?? false,
      preferredTeacherParentPerspectiveFacilitator: currentUser.preferredTeacher?.parent?.facilitator ?? false,
      preferredTeacherParentPerspectiveDemonstrator: currentUser.preferredTeacher?.parent?.demonstrator ?? false,
      preferredTeacherParentPerspectiveHybrid: currentUser.preferredTeacher?.parent?.hybrid ?? false,
      preferredTeacherParentPerspectiveOthersBox: currentUser.preferredTeacher?.parent?.others ?? false,
      preferredTeacherParentPerspectiveOthersField: currentUser.preferredTeacher?.parent?.others_type ?? '',

      interestedTopicsPublicSpeaking: currentUser.interestedTopics?.public_speaking ?? false,
      interestedTopicsDebate: currentUser.interestedTopics?.debate ?? false,
      interestedTopicsCoding: currentUser.interestedTopics?.coding ?? false,
      interestedTopicsLeadership: currentUser.interestedTopics?.leadership ?? false,
      interestedTopicsWriting: currentUser.interestedTopics?.writing ?? false,
      interestedTopicsCreativeWriting: currentUser.interestedTopics?.creative_writing ?? false,
      interestedTopicsFormalWriting: currentUser.interestedTopics?.formal_writing ?? false,
      interestedTopicsReadingComprehension: currentUser.interestedTopics?.reading_comprehension ?? false,
      interestedTopicsLiterature: currentUser.interestedTopics?.literature ?? false,
      interestedTopicsOthersBox: currentUser.interestedTopics?.others ?? false,
      interestedTopicsOthersField: currentUser.interestedTopics?.others_type ?? '',

      parentSalute: parent?.salute ?? 'Mr',
      parentName: parent?.name ?? '',
      parentEmail: parent?.email ?? '',
      parentPhoneCountryCode,
      parentPhone: parent?.phone ?? '',
      parentGender: parent?.gender ?? 'nil',
      parentDOB: parent?.dob ? moment(parent?.dob).startOf('day').format('YYYY-MM-DD') : '',
      parentPhone: parent?.phone ?? '',
      parentContactPreference: parent?.contact_preference?.contact ?? '',
      parentContactPreferenceOther: parent?.contact_preference?.others_type ?? '',
      parentFacebook: parent?.facebook ?? '',
      parentLine: parent?.line ?? '',

      parentOccupation: parent?.meta?.occupation?.area ?? '',
      parentOccupationSpecific: parent?.meta?.occupation?.specific ?? '',
      parentFamilyBackground: parent?.meta?.family_background ?? '',
      parentNetworkingFB: parent?.meta?.networking_circle?.fb ?? false,
      parentNetworkingWebsite: parent?.meta?.networking_circle?.website ?? false,
      parentNetworkingFriends: parent?.meta?.networking_circle?.friends ?? false,
      parentNetworkingOthersBox: parent?.meta?.networking_circle?.others ?? false,
      parentNetworkingOthersField: parent?.meta?.networking_circle?.others_type ?? '',

      pcDominanceDirect: parent?.meta?.parent_character?.dominance?.direct ?? false,
      pcDominanceResultsOriented: parent?.meta?.parent_character?.dominance?.result_oriented ?? false,
      pcDominanceFirm: parent?.meta?.parent_character?.dominance?.firm ?? false,
      pcDominanceStrongWilled: parent?.meta?.parent_character?.dominance?.strong_willed ?? false,
      pcDominanceForceful: parent?.meta?.parent_character?.dominance?.forceful ?? false,
      pcInfluenceOutgoing: parent?.meta?.parent_character?.influence?.outgoing ?? false,
      pcInfluenceEnthusiastic: parent?.meta?.parent_character?.influence?.enthusiastic ?? false,
      pcInfluenceOptimistic: parent?.meta?.parent_character?.influence?.optimistic ?? false,
      pcInfluenceHighSpirited: parent?.meta?.parent_character?.influence?.high_spirited ?? false,
      pcInfluenceLively: parent?.meta?.parent_character?.influence?.lively ?? false,
      pcConscientiousnessAnalytical: parent?.meta?.parent_character?.conscientiousness?.analytical ?? false,
      pcConscientiousnessReserved: parent?.meta?.parent_character?.conscientiousness?.reserved ?? false,
      pcConscientiousnessPrecise: parent?.meta?.parent_character?.conscientiousness?.precise ?? false,
      pcConscientiousnessPrivate: parent?.meta?.parent_character?.conscientiousness?.private ?? false,
      pcConscientiousnessSystematic: parent?.meta?.parent_character?.conscientiousness?.systematic ?? false,
      pcSteadinessEvenTempered: parent?.meta?.parent_character?.steadiness?.even_tempered ?? false,
      pcSteadinessAccommodating: parent?.meta?.parent_character?.steadiness?.accommodating ?? false,
      pcSteadinessPatient: parent?.meta?.parent_character?.steadiness?.patient ?? false,
      pcSteadinessHumble: parent?.meta?.parent_character?.steadiness?.humble ?? false,
      pcSteadinessTactful: parent?.meta?.parent_character?.steadiness?.tactful ?? false,
      parentConflict: parent?.meta?.conflict ?? '',
      parentDecisionFather: parent?.meta?.decision_maker?.father ?? false,
      parentDecisionMother: parent?.meta?.decision_maker?.mother ?? false,

      paymentMode: parent?.meta?.payment_mode ?? 'nil',
      parentInterestedTopicsPublicSpeaking: parent?.meta?.interested_topics?.public_speaking ?? false,
      parentInterestedTopicsDebate: parent?.meta?.interested_topics?.debate ?? false,
      parentInterestedTopicsCoding: parent?.meta?.interested_topics?.coding ?? false,
      parentInterestedTopicsLeadership: parent?.meta?.interested_topics?.leadership ?? false,
      parentInterestedTopicsWriting: parent?.meta?.interested_topics?.writing ?? false,
      parentInterestedTopicsCreativeWriting: parent?.meta?.interested_topics?.creative_writing ?? false,
      parentInterestedTopicsFormalWriting: parent?.meta?.interested_topics?.formal_writing ?? false,
      parentInterestedTopicsReadingComprehension: parent?.meta?.interested_topics?.reading_comprehension ?? false,
      parentInterestedTopicsLiterature: parent?.meta?.interested_topics?.literature ?? false,
      parentInterestedTopicsOthersBox: parent?.meta?.interested_topics?.others ?? false,
      parentInterestedTopicsOthersField: parent?.meta?.interested_topics?.others_type ?? '',
      parentDateOfRenewal: parent?.meta?.date_of_renewal
        ? moment(parent?.meta?.date_of_renewal).startOf('day').format('YYYY-MM-DD')
        : ''
    })
  }

  validateFormElement = (type, customMsg) => {
    let errorMsg

    if (type === 'password') {
      errorMsg = validatePassword(this.state.password)
    } else {
      if (customMsg) {
        errorMsg = validateTextEntry(this.state[type], type, customMsg)
      } else {
        errorMsg = validateTextEntry(this.state[type], type)
      }
    }

    let tempFormError = this.state.formError
    if (errorMsg) {
      tempFormError[type] = errorMsg
    } else {
      delete tempFormError[type]
    }
    this.setState({ formError: tempFormError })
  }

  onFocusFormElement = e => {
    let type = e.target.name
    let tempFormError = this.state.formError
    delete tempFormError[type]
    this.setState({ formError: tempFormError })
  }

  handleChange = e => {
    let type = e.target.name
    let value = e.target.value
    this.setState({ [type]: value })

    if (type === 'level') {
      let tempFormError = this.state.formError
      delete tempFormError[type]
      this.setState({ formError: tempFormError })
      if (value === 'others') {
        this.setState({ showOthersLevel: true })
      } else {
        this.setState({ showOthersLevel: false })
      }
    }

    if (type === 'typeOfSchool') {
      if (value === 'others') {
        this.setState({ showOthersTypeOfSchool: true })
      } else {
        this.setState({ showOthersTypeOfSchool: false })
      }
    }
  }

  handleClose = (event, reason) => {
    const { isSaved } = this.state
    if (reason === 'clickaway') {
      return
    }

    this.setState({ isSaved: !isSaved })
  }

  handleBlurInput = e => {
    this.setState({ [e.target.name]: e.target.value })
  }

  handleAutoCompleteChange = (e, value) => {
    this.setState({ school: value.name })

    if (value.code === 'others') {
      this.setState({ showOthersSchool: true })
    } else {
      this.setState({ showOthersSchool: false })
    }
  }

  handleAutoCompleteStudyAreaChange = (e, value) => {
    this.setState({ areaOfStudy: value })
  }

  handleAutoCompleteStudyAreaSpecificChange = (e, value) => {
    this.setState({ areaOfStudySpecific: value })
  }

  handleAutoCompleteStudyAreaChange1 = (e, value) => {
    this.setState({ areaOfStudy1: value })
  }

  handleAutoCompleteStudyAreaSpecificChange1 = (e, value) => {
    this.setState({ areaOfStudySpecific1: value })
  }

  handleAutoCompleteStudyAreaChange2 = (e, value) => {
    this.setState({ areaOfStudy2: value })
  }

  handleAutoCompleteStudyAreaSpecificChange2 = (e, value) => {
    this.setState({ areaOfStudySpecific2: value })
  }

  handleAutoCompleteStudyAreaChange3 = (e, value) => {
    this.setState({ areaOfStudy3: value })
  }

  handleAutoCompleteStudyAreaSpecificChange3 = (e, value) => {
    this.setState({ areaOfStudySpecific3: value })
  }

  handleAutoCompleteStudyAreaChange4 = (e, value) => {
    this.setState({ areaOfStudy4: value })
  }

  handleAutoCompleteStudyAreaSpecificChange4 = (e, value) => {
    this.setState({ areaOfStudySpecific4: value })
  }

  handleCheckboxChange = (e, checked) => {
    this.setState({ [e.target.name]: checked })
  }

  submitChanges = () => {
    this.validateFormElement('name')
    this.validateFormElement('phone')
    if (this.state.level === 'others') {
      this.validateFormElement('othersLevel', 'your level')
    } else {
      this.validateFormElement('level')
    }
    this.validateFormElement('school')
    if (_.isEmpty(this.state.formError)) {
      const {
        name,
        email,
        dateOfBirth,
        gender,
        phoneCountryCode,
        phone,
        level,
        othersLevel,
        school,
        othersSchool,
        typeOfSchool,
        othersTypeOfSchool,

        contactPreference,
        contactPreferenceOther,
        facebook,
        line,
        isSaved,

        studyingAtOtherSchool,
        studyingAtOtherSchoolName,
        studyMediumEng,
        studyMediumThai,
        gradeLevel,
        yearLevel,

        gpaEngBox,
        gpaThaiBox,
        gpaMathsBox,
        gpaPhysBox,
        gpaChemBox,
        gpaBioBox,
        gpaGeoBox,
        gpaHistBox,
        gpaLitBox,
        gpaSSBox,
        gpaPolBox,
        gpaEcoBox,
        gpaArtBox,
        gpaFLBox,
        gpaOthersBox,

        gpaEng,
        gpaThai,
        gpaMaths,
        gpaPhys,
        gpaChem,
        gpaBio,
        gpaGeo,
        gpaHist,
        gpaLit,
        gpaSS,
        gpaPol,
        gpaEco,
        gpaArt,
        gpaFL,
        gpaOthersField,

        favSubjEngBox,
        favSubjThaiBox,
        favSubjMathsBox,
        favSubjPhysBox,
        favSubjChemBox,
        favSubjBioBox,
        favSubjGeoBox, //geography
        favSubjHistBox,
        favSubjLitBox, //literature
        favSubjSSBox, //social studies
        favSubjPolBox, //politics
        favSubjEcoBox, //economics
        favSubjArtBox,
        favSubjFLBox, //foreign language,
        favSubjOthersBox,
        favSubjOthersBoxField,

        weakestSubjEngBox,
        weakestSubjThaiBox,
        weakestSubjMathsBox,
        weakestSubjPhysBox,
        weakestSubjChemBox,
        weakestSubjBioBox,
        weakestSubjGeoBox, //geography
        weakestSubjHistBox,
        weakestSubjLitBox, //literature
        weakestSubjSSBox, //social studies
        weakestSubjPolBox, //politics
        weakestSubjEcoBox, //economics
        weakestSubjArtBox,
        weakestSubjFLBox, //foreign ,
        weakestSubjOthersBox,
        weakestSubjOthersBoxField,

        extExamSAT,
        extExamGRE,
        extExamIELTS,
        extExamTOEFL,
        extExamGMAT,
        extExamOthers,
        extExamOthersField,

        otherTCcourseSAT,
        otherTCcourseGRE,
        otherTCcourseIELTS,
        otherTCcourseTOEFL,
        otherTCcourseGMAT,
        otherTCcourseEnglish,
        otherTCcourseThai,
        otherTCcourseMath,
        otherTCcoursePhysics,
        otherTCcourseBiology,
        otherTCcourseChemistry,
        otherTCcourseGeography,
        otherTCcourseHistory,
        otherTCcourseLiterature,
        otherTCcourseSocialStudies,
        otherTCcoursePolitics,
        otherTCcourseEconomics,
        otherTCcourseArt,
        otherTCcourseForeignLanguage,
        otherTCcourseOthers,
        otherTCcourseOthersField,

        studyingAtEPA,
        coursesTakenAtEpaSAT,
        coursesTakenAtEpaGRE,
        coursesTakenAtEpaIELTS,
        coursesTakenAtEpaTOEFL,
        coursesTakenAtEpaGMAT,
        coursesTakenAtEpaEnglish,
        coursesTakenAtEpaThai,
        coursesTakenAtEpaMath,
        coursesTakenAtEpaPhysics,
        coursesTakenAtEpaBiology,
        coursesTakenAtEpaGeography,
        coursesTakenAtEpaChemistry,
        coursesTakenAtEpaHistory,
        coursesTakenAtEpaLiterature,
        coursesTakenAtEpaSocialStudies,
        coursesTakenAtEpaPolitics,
        coursesTakenAtEpaEconomics,
        coursesTakenAtEpaArt,
        coursesTakenAtEpaForeignLanguage,
        coursesTakenAtEpaOthers,
        coursesTakenAtEpaOthersField,

        needConsultationForACC,

        careerGoalsStudentPerspective,
        careerGoalsParentPerspective,

        studyGoalsStudentPerspectiveEntranceExamBox,
        studyGoalsStudentPerspectiveEntranceExamField,
        studyGoalsStudentPerspectiveSchoolExamBox,
        studyGoalsStudentPerspectiveSATBox,
        studyGoalsStudentPerspectiveGREBox,
        studyGoalsStudentPerspectiveIELTSBox,
        studyGoalsStudentPerspectiveTOEFLBox,
        studyGoalsStudentPerspectiveGMATBox,
        studyGoalsStudentPerspectiveOthersBox,
        studyGoalsStudentPerspectiveOthersField,

        studyGoalsParentPerspectiveEntranceExamBox,
        studyGoalsParentPerspectiveEntranceExamField,
        studyGoalsParentPerspectiveSchoolExamBox,
        studyGoalsParentPerspectiveSATBox,
        studyGoalsParentPerspectiveGREBox,
        studyGoalsParentPerspectiveIELTSBox,
        studyGoalsParentPerspectiveTOEFLBox,
        studyGoalsParentPerspectiveGMATBox,
        studyGoalsParentPerspectiveOthersBox,
        studyGoalsParentPerspectiveOthersField,

        targetCountryStudentUS,
        targetCountryStudentCanada,
        targetCountryStudentUK,
        targetCountryStudentAustralia,
        targetCountryStudentNewZealand,
        targetCountryStudentOthersBox,
        targetCountryStudentOthersField,

        targetCountryParentUS,
        targetCountryParentCanada,
        targetCountryParentUK,
        targetCountryParentAustralia,
        targetCountryParentNewZealand,
        targetCountryParentOthersBox,
        targetCountryParentOthersField,

        areaOfStudy,
        areaOfStudySpecific,
        areaOfStudy1,
        areaOfStudySpecific1,
        areaOfStudy2,
        areaOfStudySpecific2,
        areaOfStudy3,
        areaOfStudySpecific3,
        areaOfStudy4,
        areaOfStudySpecific4,
        areaOfStudyOthers,
        areaOfStudyOthersField,
        areaOfStudyUnsure,

        areaOfStudyParent,
        areaOfStudyParentSpecific,
        areaOfStudyParent1,
        areaOfStudyParentSpecific1,
        areaOfStudyParent2,
        areaOfStudyParentSpecific2,
        areaOfStudyParent3,
        areaOfStudyParentSpecific3,
        areaOfStudyParent4,
        areaOfStudyParentSpecific4,
        areaOfStudyParentOthers,
        areaOfStudyParentOthersField,
        areaOfStudyParentUnsure,

        specialRequests,

        learningTypeVisual,
        learningTypeKinaesthetic,
        learningTypeAural,
        learningTypeSocial,
        learningTypeSolitary,
        learningTypeVerbal,
        learningTypeLogical,
        learningTypeUnsure,
        learningTypeOthersBox,
        learningTypeOthersField,

        personalityTestCheck,
        personalityTestResult,
        personalityTestResultField,

        scDominanceDirect,
        scDominanceResultsOriented,
        scDominanceFirm,
        scDominanceStrongWilled,
        scDominanceForceful,
        scInfluenceOutgoing,
        scInfluenceEnthusiastic,
        scInfluenceOptimistic,
        scInfluenceHighSpirited,
        scInfluenceLively,
        scConscientiousnessAnalytical,
        scConscientiousnessReserved,
        scConscientiousnessPrecise,
        scConscientiousnessPrivate,
        scConscientiousnessSystematic,
        scSteadinessEvenTempered,
        scSteadinessAccommodating,
        scSteadinessPatient,
        scSteadinessHumble,
        scSteadinessTactful,

        healthConditionNA,
        healthConditionADHD,
        healthConditionAutism,
        healthConditionOthersBox,
        healthConditionOthersField,

        preferredTeacherStudentPerspectiveMale,
        preferredTeacherStudentPerspectiveFemale,
        preferredTeacherStudentPerspectiveNameBox,
        preferredTeacherStudentPerspectiveNameField,
        preferredTeacherStudentPerspectiveAuthority,
        preferredTeacherStudentPerspectiveDelegator,
        preferredTeacherStudentPerspectiveFacilitator,
        preferredTeacherStudentPerspectiveDemonstrator,
        preferredTeacherStudentPerspectiveHybrid,
        preferredTeacherStudentPerspectiveOthersBox,
        preferredTeacherStudentPerspectiveOthersField,

        preferredTeacherParentPerspectiveMale,
        preferredTeacherParentPerspectiveFemale,
        preferredTeacherParentPerspectiveNameBox,
        preferredTeacherParentPerspectiveNameField,
        preferredTeacherParentPerspectiveAuthority,
        preferredTeacherParentPerspectiveDelegator,
        preferredTeacherParentPerspectiveFacilitator,
        preferredTeacherParentPerspectiveDemonstrator,
        preferredTeacherParentPerspectiveHybrid,
        preferredTeacherParentPerspectiveOthersBox,
        preferredTeacherParentPerspectiveOthersField,

        interestedTopicsPublicSpeaking,
        interestedTopicsDebate,
        interestedTopicsCoding,
        interestedTopicsLeadership,
        interestedTopicsWriting,
        interestedTopicsCreativeWriting,
        interestedTopicsFormalWriting,
        interestedTopicsReadingComprehension,
        interestedTopicsLiterature,
        interestedTopicsOthersBox,
        interestedTopicsOthersField,

        parentSalute,
        parentName,
        parentGender,
        parentDOB,
        parentEmail,
        parentPhoneCountryCode,
        parentPhone,
        parentContactPreference,
        parentContactPreferenceOther,
        parentFacebook,
        parentLine,

        parentOccupation,
        parentOccupationSpecific,
        parentFamilyBackground,
        parentNetworkingFB,
        parentNetworkingWebsite,
        parentNetworkingFriends,
        parentNetworkingOthersBox,
        parentNetworkingOthersField,

        pcDominanceDirect,
        pcDominanceResultsOriented,
        pcDominanceFirm,
        pcDominanceStrongWilled,
        pcDominanceForceful,
        pcInfluenceOutgoing,
        pcInfluenceEnthusiastic,
        pcInfluenceOptimistic,
        pcInfluenceHighSpirited,
        pcInfluenceLively,
        pcConscientiousnessAnalytical,
        pcConscientiousnessReserved,
        pcConscientiousnessPrecise,
        pcConscientiousnessPrivate,
        pcConscientiousnessSystematic,
        pcSteadinessEvenTempered,
        pcSteadinessAccommodating,
        pcSteadinessPatient,
        pcSteadinessHumble,
        pcSteadinessTactful,
        parentConflict,
        parentDecisionFather,
        parentDecisionMother,

        paymentMode,
        parentInterestedTopicsPublicSpeaking,
        parentInterestedTopicsDebate,
        parentInterestedTopicsCoding,
        parentInterestedTopicsLeadership,
        parentInterestedTopicsWriting,
        parentInterestedTopicsCreativeWriting,
        parentInterestedTopicsFormalWriting,
        parentInterestedTopicsReadingComprehension,
        parentInterestedTopicsLiterature,
        parentInterestedTopicsOthersBox,
        parentInterestedTopicsOthersField,
        parentDateOfRenewal
      } = this.state

      this.setState({ isSaved: !isSaved })

      let details = {
        name,
        phone,
        gender,
        date_of_birth: moment(dateOfBirth).startOf('day').toISOString(),
        phone_country_code: phoneCountryCode,
        level: level === 'others' ? othersLevel : level,
        school: school === 'others' ? othersSchool : school === 'Others' ? othersSchool : school,
        typeOfSchool: typeOfSchool === 'others' ? othersTypeOfSchool : typeOfSchool,

        contact_preference: {
          contact: contactPreference,
          others_type: contactPreferenceOther
        },
        facebook: facebook,
        line: line,

        gradeYearLevel: {
          grade: gradeLevel,
          year: yearLevel
        },

        grade: {
          english: gpaEngBox,
          thai: gpaThaiBox,
          math: gpaMathsBox,
          physics: gpaPhysBox,
          chemistry: gpaChemBox,
          biology: gpaBioBox,
          geography: gpaGeoBox,
          history: gpaHistBox,
          literature: gpaLitBox,
          social_studies: gpaSSBox,
          politics: gpaPolBox,
          economics: gpaEcoBox,
          art: gpaArtBox,
          foreign_language: gpaFLBox,
          others: gpaOthersBox,

          gpa: {
            english: gpaEng,
            thai: gpaThai,
            math: gpaMaths,
            physics: gpaPhys,
            chemistry: gpaChem,
            biology: gpaBio,
            geography: gpaGeo,
            history: gpaHist,
            literature: gpaLit,
            social_studies: gpaSS,
            politics: gpaPol,
            economics: gpaEco,
            art: gpaArt,
            foreign_language: gpaFL,
            others_type: gpaOthersField
          }
        },

        favoriteSubjects: {
          english: favSubjEngBox,
          thai: favSubjThaiBox,
          math: favSubjMathsBox,
          physics: favSubjPhysBox,
          chemistry: favSubjChemBox,
          biology: favSubjBioBox,
          geography: favSubjGeoBox,
          history: favSubjHistBox,
          literature: favSubjLitBox,
          social_studies: favSubjSSBox,
          politics: favSubjPolBox,
          economics: favSubjEcoBox,
          art: favSubjArtBox,
          foreign_language: favSubjFLBox,
          others: favSubjOthersBox,
          others_type: favSubjOthersBoxField
        },

        weakestSubjects: {
          english: weakestSubjEngBox,
          thai: weakestSubjThaiBox,
          math: weakestSubjMathsBox,
          physics: weakestSubjPhysBox,
          chemistry: weakestSubjChemBox,
          biology: weakestSubjBioBox,
          geography: weakestSubjGeoBox,
          history: weakestSubjHistBox,
          literature: weakestSubjLitBox,
          social_studies: weakestSubjSSBox,
          politics: weakestSubjPolBox,
          economics: weakestSubjEcoBox,
          art: weakestSubjArtBox,
          foreign_language: weakestSubjFLBox,
          others: weakestSubjOthersBox,
          others_type: weakestSubjOthersBoxField
        },

        externalExams: {
          gmat: extExamGMAT,
          gre: extExamGRE,
          ielts: extExamIELTS,
          sat: extExamSAT,
          toefl: extExamTOEFL,
          others: extExamOthers,
          others_type: extExamOthersField
        },

        coursesTuition: {
          gmat: otherTCcourseGMAT,
          gre: otherTCcourseGRE,
          ielts: otherTCcourseIELTS,
          sat: otherTCcourseSAT,
          toefl: otherTCcourseTOEFL,
          english: otherTCcourseEnglish,
          thai: otherTCcourseThai,
          math: otherTCcourseMath,
          physics: otherTCcoursePhysics,
          biology: otherTCcourseBiology,
          chemistry: otherTCcourseChemistry,
          geography: otherTCcourseGeography,
          history: otherTCcourseHistory,
          literature: otherTCcourseLiterature,
          social_studies: otherTCcourseSocialStudies,
          politics: otherTCcoursePolitics,
          economics: otherTCcourseEconomics,
          art: otherTCcourseArt,
          foreign_language: otherTCcourseForeignLanguage,
          others: otherTCcourseOthers,
          others_type: otherTCcourseOthersField
        },

        currentlyAtEPA: {
          studyingAtEPA: studyingAtEPA,
          coursesTakenAtEPA: {
            sat: coursesTakenAtEpaSAT,
            gre: coursesTakenAtEpaGRE,
            ielts: coursesTakenAtEpaIELTS,
            toefl: coursesTakenAtEpaTOEFL,
            gmat: coursesTakenAtEpaGMAT,
            english: coursesTakenAtEpaEnglish,
            thai: coursesTakenAtEpaThai,
            math: coursesTakenAtEpaMath,
            physics: coursesTakenAtEpaPhysics,
            biology: coursesTakenAtEpaBiology,
            geography: coursesTakenAtEpaGeography,
            chemistry: coursesTakenAtEpaChemistry,
            history: coursesTakenAtEpaHistory,
            literature: coursesTakenAtEpaLiterature,
            social_studies: coursesTakenAtEpaSocialStudies,
            politics: coursesTakenAtEpaPolitics,
            economics: coursesTakenAtEpaEconomics,
            art: coursesTakenAtEpaArt,
            foreign_language: coursesTakenAtEpaForeignLanguage,
            others: coursesTakenAtEpaOthers,
            others_type: coursesTakenAtEpaOthersField
          }
        },

        studyingAtOtherSchool: {
          at_other_school: studyingAtOtherSchool,
          at_other_school_name: studyingAtOtherSchoolName
        },

        studyMediumEng: studyMediumEng,
        studyMediumThai: studyMediumThai,

        careerGoals: {
          consultation: needConsultationForACC,
          student: careerGoalsStudentPerspective,
          parent: careerGoalsParentPerspective
        },

        studyGoals: {
          student: {
            entrance: studyGoalsStudentPerspectiveEntranceExamBox,
            entrance_type: studyGoalsStudentPerspectiveEntranceExamField,
            school_exam: studyGoalsStudentPerspectiveSchoolExamBox,
            sat: studyGoalsStudentPerspectiveSATBox,
            gre: studyGoalsStudentPerspectiveGREBox,
            ielts: studyGoalsStudentPerspectiveIELTSBox,
            toefl: studyGoalsStudentPerspectiveTOEFLBox,
            gmat: studyGoalsStudentPerspectiveGMATBox,
            others: studyGoalsStudentPerspectiveOthersBox,
            others_type: studyGoalsStudentPerspectiveOthersField
          },
          parent: {
            entrance: studyGoalsParentPerspectiveEntranceExamBox,
            entrance_type: studyGoalsParentPerspectiveEntranceExamField,
            school_exam: studyGoalsParentPerspectiveSchoolExamBox,
            sat: studyGoalsParentPerspectiveSATBox,
            gre: studyGoalsParentPerspectiveGREBox,
            ielts: studyGoalsParentPerspectiveIELTSBox,
            toefl: studyGoalsParentPerspectiveTOEFLBox,
            gmat: studyGoalsParentPerspectiveGMATBox,
            others: studyGoalsParentPerspectiveOthersBox,
            others_type: studyGoalsParentPerspectiveOthersField
          }
        },

        targetCountry: {
          student: {
            us: targetCountryStudentUS,
            canada: targetCountryStudentCanada,
            uk: targetCountryStudentUK,
            aus: targetCountryStudentAustralia,
            nz: targetCountryStudentNewZealand,
            others: targetCountryStudentOthersBox,
            others_type: targetCountryStudentOthersField
          },
          parent: {
            us: targetCountryParentUS,
            canada: targetCountryParentCanada,
            uk: targetCountryParentUK,
            aus: targetCountryParentAustralia,
            nz: targetCountryParentNewZealand,
            others: targetCountryParentOthersBox,
            others_type: targetCountryParentOthersField
          }
        },

        areaOfStudy: {
          area: areaOfStudy,
          specific: areaOfStudySpecific,
          area1: areaOfStudy1,
          specific1: areaOfStudySpecific1,
          area2: areaOfStudy2,
          specific2: areaOfStudySpecific2,
          area3: areaOfStudy3,
          specific3: areaOfStudySpecific3,
          area4: areaOfStudy4,
          specific4: areaOfStudySpecific4,
          others: areaOfStudyOthers,
          others_type: areaOfStudyOthersField,
          unsure: areaOfStudyUnsure,
          // to prevent from disappearing when updating //continue here
          parent: {
            area: areaOfStudyParent,
            specific: areaOfStudyParentSpecific,
            area1: areaOfStudyParent1,
            specific1: areaOfStudyParentSpecific1,
            area2: areaOfStudyParent2,
            specific2: areaOfStudyParentSpecific2,
            area3: areaOfStudyParent3,
            specific3: areaOfStudyParentSpecific3,
            area4: areaOfStudyParent4,
            specific4: areaOfStudyParentSpecific4,
            others: areaOfStudyParentOthers,
            others_type: areaOfStudyParentOthersField,
            unsure: areaOfStudyParentUnsure
          }
        },

        specialRequests: specialRequests,

        learningType: {
          visual: learningTypeVisual,
          kinaesthetic: learningTypeKinaesthetic,
          aural: learningTypeAural,
          social: learningTypeSocial,
          solitary: learningTypeSolitary,
          verbal: learningTypeVerbal,
          logical: learningTypeLogical,
          unsure: learningTypeUnsure,
          others: learningTypeOthersBox,
          others_type: learningTypeOthersField
        },

        studentCharacter: {
          dominance: {
            direct: scDominanceDirect,
            result_oriented: scDominanceResultsOriented,
            firm: scDominanceFirm,
            strong_willed: scDominanceStrongWilled,
            forceful: scDominanceForceful
          },
          influence: {
            outgoing: scInfluenceOutgoing,
            enthusiastic: scInfluenceEnthusiastic,
            optimistic: scInfluenceOptimistic,
            high_spirited: scInfluenceHighSpirited,
            lively: scInfluenceLively
          },
          conscientiousness: {
            analytical: scConscientiousnessAnalytical,
            reserved: scConscientiousnessReserved,
            precise: scConscientiousnessPrecise,
            private: scConscientiousnessPrivate,
            systematic: scConscientiousnessSystematic
          },
          steadiness: {
            even_tempered: scSteadinessEvenTempered,
            accommodating: scSteadinessAccommodating,
            patient: scSteadinessPatient,
            humble: scSteadinessHumble,
            tactful: scSteadinessTactful
          }
        },

        personalityTest: {
          attempted: personalityTestCheck,
          result: personalityTestResult,
          result_field: personalityTestResultField
        },

        healthCondition: {
          na: healthConditionNA,
          adhd: healthConditionADHD,
          autism: healthConditionAutism,
          others: healthConditionOthersBox,
          others_type: healthConditionOthersField
        },

        preferredTeacher: {
          student: {
            male: preferredTeacherStudentPerspectiveMale,
            female: preferredTeacherStudentPerspectiveFemale,
            name: preferredTeacherStudentPerspectiveNameBox,
            name_type: preferredTeacherStudentPerspectiveNameField,
            authority: preferredTeacherStudentPerspectiveAuthority,
            delegator: preferredTeacherStudentPerspectiveDelegator,
            facilitator: preferredTeacherStudentPerspectiveFacilitator,
            demonstrator: preferredTeacherStudentPerspectiveDemonstrator,
            hybrid: preferredTeacherStudentPerspectiveHybrid,
            others: preferredTeacherStudentPerspectiveOthersBox,
            others_type: preferredTeacherStudentPerspectiveOthersField
          },
          parent: {
            male: preferredTeacherParentPerspectiveMale,
            female: preferredTeacherParentPerspectiveFemale,
            name: preferredTeacherParentPerspectiveNameBox,
            name_type: preferredTeacherParentPerspectiveNameField,
            authority: preferredTeacherParentPerspectiveAuthority,
            delegator: preferredTeacherParentPerspectiveDelegator,
            facilitator: preferredTeacherParentPerspectiveFacilitator,
            demonstrator: preferredTeacherParentPerspectiveDemonstrator,
            hybrid: preferredTeacherParentPerspectiveHybrid,
            others: preferredTeacherParentPerspectiveOthersBox,
            others_type: preferredTeacherParentPerspectiveOthersField
          }
        },

        interestedTopics: {
          public_speaking: interestedTopicsPublicSpeaking,
          debate: interestedTopicsDebate,
          coding: interestedTopicsCoding,
          writing: interestedTopicsWriting,
          leadership: interestedTopicsLeadership,
          creative_writing: interestedTopicsCreativeWriting,
          formal_writing: interestedTopicsFormalWriting,
          reading_comprehension: interestedTopicsReadingComprehension,
          literature: interestedTopicsLiterature,
          others: interestedTopicsOthersBox,
          others_type: interestedTopicsOthersField
        },

        parent: {
          _type: 'Parent',
          salute: parentSalute,
          name: parentName,
          // child: ,
          child_email: email,
          child_name: name,
          email: parentEmail,
          gender: parentGender,
          dob: parentDOB,
          phone_country_code: parentPhoneCountryCode,
          phone: parentPhone,
          contact_preference: {
            contact: parentContactPreference,
            others_type: parentContactPreferenceOther
          },
          facebook: parentFacebook,
          line: parentLine,
          meta: {
            occupation: {
              area: parentOccupation,
              specific: parentOccupationSpecific
            },
            family_background: parentFamilyBackground,
            networking_circle: {
              fb: parentNetworkingFB,
              website: parentNetworkingWebsite,
              friends: parentNetworkingFriends,
              others: parentNetworkingOthersBox,
              others_type: parentNetworkingOthersField
            },
            interested_topics: {
              public_speaking: parentInterestedTopicsPublicSpeaking,
              debate: parentInterestedTopicsDebate,
              coding: parentInterestedTopicsCoding,
              writing: parentInterestedTopicsWriting,
              leadership: parentInterestedTopicsLeadership,
              creative_writing: parentInterestedTopicsCreativeWriting,
              formal_writing: parentInterestedTopicsFormalWriting,
              reading_comprehension: parentInterestedTopicsReadingComprehension,
              literature: parentInterestedTopicsLiterature,
              others: parentInterestedTopicsOthersBox,
              others_type: parentInterestedTopicsOthersField
            },
            conflict: parentConflict,
            decision_maker: {
              father: parentDecisionFather,
              mother: parentDecisionMother
            },
            parent_character: {
              dominance: {
                direct: pcDominanceDirect,
                result_oriented: pcDominanceResultsOriented,
                firm: pcDominanceFirm,
                strong_willed: pcDominanceStrongWilled,
                forceful: pcDominanceForceful
              },
              influence: {
                outgoing: pcInfluenceOutgoing,
                enthusiastic: pcInfluenceEnthusiastic,
                optimistic: pcInfluenceOptimistic,
                high_spirited: pcInfluenceHighSpirited,
                lively: pcInfluenceLively
              },
              conscientiousness: {
                analytical: pcConscientiousnessAnalytical,
                reserved: pcConscientiousnessReserved,
                precise: pcConscientiousnessPrecise,
                private: pcConscientiousnessPrivate,
                systematic: pcConscientiousnessSystematic
              },
              steadiness: {
                even_tempered: pcSteadinessEvenTempered,
                accommodating: pcSteadinessAccommodating,
                patient: pcSteadinessPatient,
                humble: pcSteadinessHumble,
                tactful: pcSteadinessTactful
              }
            },
            payment_mode: paymentMode,
            date_of_renewal: parentDateOfRenewal
          }
        }
      }
      this.props.updateUser(details)
      // this.props.updateParentMeta(this.props.currentUser.parent.email, details)
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.phoneCountryCode !== this.state.phoneCountryCode || prevState.phone !== this.state.phone) {
      if (this.state.useStudentPhone) {
        this.setState({
          parentPhoneCountryCode: this.state.phoneCountryCode,
          parentPhone: this.state.phone
        })
      }
    }

    // if (prevProps.updateUserInProgress && !this.props.updateUserInProgress) {
    //   this.props.history.push(USER_PROFILE)
    // }
  }

  render() {
    const { updateUserInProgress, currentUser } = this.props
    const {
      email,
      name,
      dateOfBirth,
      gender,
      phoneCountryCode,
      phone,
      level,
      othersLevel,
      showOthersLevel,

      formError,
      parentEmail,
      useStudentEmail,
      parentSalute,
      parentName,
      parentPhoneCountryCode,
      parentPhone,
      useStudentPhone,
      contactPreference,
      contactPreferenceOther,
      facebook,
      line,
      isSaved,

      gradeLevel,
      yearLevel,

      school,
      othersSchool,
      showOthersSchool,
      typeOfSchool,
      othersTypeOfSchool,
      showOthersTypeOfSchool,
      studyingAtOtherSchool,
      studyingAtOtherSchoolName,
      studyMediumEng,
      studyMediumThai,

      gpaEngBox,
      gpaThaiBox,
      gpaMathsBox,
      gpaPhysBox,
      gpaChemBox,
      gpaBioBox,
      gpaGeoBox,
      gpaHistBox,
      gpaLitBox,
      gpaSSBox,
      gpaPolBox,
      gpaEcoBox,
      gpaArtBox,
      gpaFLBox,
      gpaOthersBox,
      gpaEng,
      gpaThai,
      gpaMaths,
      gpaPhys,
      gpaChem,
      gpaBio,
      gpaGeo,
      gpaHist,
      gpaLit,
      gpaSS,
      gpaPol,
      gpaEco,
      gpaArt,
      gpaFL,
      gpaOthersField,
      favSubjEngBox,
      favSubjThaiBox,
      favSubjMathsBox,
      favSubjPhysBox,
      favSubjChemBox,
      favSubjBioBox,
      favSubjGeoBox,
      favSubjHistBox,
      favSubjLitBox,
      favSubjSSBox,
      favSubjPolBox,
      favSubjEcoBox,
      favSubjArtBox,
      favSubjFLBox,
      favSubjOthersBox,
      favSubjOthersBoxField,
      weakestSubjEngBox,
      weakestSubjThaiBox,
      weakestSubjMathsBox,
      weakestSubjPhysBox,
      weakestSubjChemBox,
      weakestSubjBioBox,
      weakestSubjGeoBox,
      weakestSubjHistBox,
      weakestSubjLitBox,
      weakestSubjSSBox,
      weakestSubjPolBox,
      weakestSubjEcoBox,
      weakestSubjArtBox,
      weakestSubjFLBox,
      weakestSubjOthersBox,
      weakestSubjOthersBoxField,
      extExamSAT,
      extExamGRE,
      extExamIELTS,
      extExamTOEFL,
      extExamGMAT,
      extExamOthers,
      extExamOthersField,
      otherTCcourseSAT,
      otherTCcourseGRE,
      otherTCcourseIELTS,
      otherTCcourseTOEFL,
      otherTCcourseGMAT,
      otherTCcourseEnglish,
      otherTCcourseThai,
      otherTCcourseMath,
      otherTCcoursePhysics,
      otherTCcourseBiology,
      otherTCcourseChemistry,
      otherTCcourseGeography,
      otherTCcourseHistory,
      otherTCcourseLiterature,
      otherTCcourseSocialStudies,
      otherTCcoursePolitics,
      otherTCcourseEconomics,
      otherTCcourseArt,
      otherTCcourseForeignLanguage,
      otherTCcourseOthers,
      otherTCcourseOthersField,
      studyingAtEPA,
      coursesTakenAtEpaSAT,
      coursesTakenAtEpaGRE,
      coursesTakenAtEpaIELTS,
      coursesTakenAtEpaTOEFL,
      coursesTakenAtEpaGMAT,
      coursesTakenAtEpaEnglish,
      coursesTakenAtEpaThai,
      coursesTakenAtEpaMath,
      coursesTakenAtEpaPhysics,
      coursesTakenAtEpaBiology,
      coursesTakenAtEpaGeography,
      coursesTakenAtEpaChemistry,
      coursesTakenAtEpaHistory,
      coursesTakenAtEpaLiterature,
      coursesTakenAtEpaSocialStudies,
      coursesTakenAtEpaPolitics,
      coursesTakenAtEpaEconomics,
      coursesTakenAtEpaArt,
      coursesTakenAtEpaForeignLanguage,
      coursesTakenAtEpaOthers,
      coursesTakenAtEpaOthersField,

      needConsultationForACC,

      careerGoalsStudentPerspective,

      areaOfStudy,
      areaOfStudySpecific,
      areaOfStudy1,
      areaOfStudySpecific1,
      areaOfStudy2,
      areaOfStudySpecific2,
      areaOfStudy3,
      areaOfStudySpecific3,
      areaOfStudy4,
      areaOfStudySpecific4,
      areaOfStudyOthers,
      areaOfStudyOthersField,
      areaOfStudyUnsure,

      specialRequests,

      studyGoalsStudentPerspectiveEntranceExamBox,
      studyGoalsStudentPerspectiveEntranceExamField,
      studyGoalsStudentPerspectiveSchoolExamBox,
      studyGoalsStudentPerspectiveSATBox,
      studyGoalsStudentPerspectiveGREBox,
      studyGoalsStudentPerspectiveIELTSBox,
      studyGoalsStudentPerspectiveTOEFLBox,
      studyGoalsStudentPerspectiveGMATBox,
      studyGoalsStudentPerspectiveOthersBox,
      studyGoalsStudentPerspectiveOthersField,

      targetCountryStudentUS,
      targetCountryStudentCanada,
      targetCountryStudentUK,
      targetCountryStudentAustralia,
      targetCountryStudentNewZealand,
      targetCountryStudentOthersBox,
      targetCountryStudentOthersField,

      learningTypeVisual,
      learningTypeKinaesthetic,
      learningTypeAural,
      learningTypeSocial,
      learningTypeSolitary,
      learningTypeVerbal,
      learningTypeLogical,
      learningTypeUnsure,
      learningTypeOthersBox,
      learningTypeOthersField,

      personalityTestCheck,
      personalityTestResult,
      personalityTestResultField,

      scDominanceDirect,
      scDominanceResultsOriented,
      scDominanceFirm,
      scDominanceStrongWilled,
      scDominanceForceful,
      scInfluenceOutgoing,
      scInfluenceEnthusiastic,
      scInfluenceOptimistic,
      scInfluenceHighSpirited,
      scInfluenceLively,
      scConscientiousnessAnalytical,
      scConscientiousnessReserved,
      scConscientiousnessPrecise,
      scConscientiousnessPrivate,
      scConscientiousnessSystematic,
      scSteadinessEvenTempered,
      scSteadinessAccommodating,
      scSteadinessPatient,
      scSteadinessHumble,
      scSteadinessTactful,

      healthConditionNA,
      healthConditionADHD,
      healthConditionAutism,
      healthConditionOthersBox,
      healthConditionOthersField,

      preferredTeacherStudentPerspectiveMale,
      preferredTeacherStudentPerspectiveFemale,
      preferredTeacherStudentPerspectiveNameBox,
      preferredTeacherStudentPerspectiveNameField,
      preferredTeacherStudentPerspectiveAuthority,
      preferredTeacherStudentPerspectiveDelegator,
      preferredTeacherStudentPerspectiveFacilitator,
      preferredTeacherStudentPerspectiveDemonstrator,
      preferredTeacherStudentPerspectiveHybrid,
      preferredTeacherStudentPerspectiveOthersBox,
      preferredTeacherStudentPerspectiveOthersField,

      interestedTopicsPublicSpeaking,
      interestedTopicsDebate,
      interestedTopicsCoding,
      interestedTopicsLeadership,
      interestedTopicsWriting,
      interestedTopicsCreativeWriting,
      interestedTopicsFormalWriting,
      interestedTopicsReadingComprehension,
      interestedTopicsLiterature,
      interestedTopicsOthersBox,
      interestedTopicsOthersField
    } = this.state

    return (
      <div className="dashboard animated slideInUpTiny animation-duration-3">
        <Paper elevation={2} className="app-wrapper">
          <h2 className="mb-0">Update Details</h2>
        </Paper>
        <div className="app-wrapper">
          <div className="container">
            <StepperProfile
              handleChange={this.handleChange}
              validateFormElement={this.validateFormElement}
              onFocusFormElement={this.onFocusFormElement}
              submitChanges={this.submitChanges}
              email={email}
              name={name}
              dateOfBirth={dateOfBirth}
              gender={gender}
              phoneCountryCode={phoneCountryCode}
              phone={phone}
              level={level}
              othersLevel={othersLevel}
              showOthersLevel={showOthersLevel}
              school={school}
              othersSchool={othersSchool}
              showOthersSchool={showOthersSchool}
              typeOfSchool={typeOfSchool}
              othersTypeOfSchool={othersTypeOfSchool}
              showOthersTypeOfSchool={showOthersTypeOfSchool}
              studyMediumEng={studyMediumEng}
              studyMediumThai={studyMediumThai}
              studyingAtOtherSchool={studyingAtOtherSchool}
              studyingAtOtherSchoolName={studyingAtOtherSchoolName}
              formError={formError}
              parentEmail={parentEmail}
              useStudentEmail={useStudentEmail}
              parentSalute={parentSalute}
              parentName={parentName}
              parentPhoneCountryCode={parentPhoneCountryCode}
              parentPhone={parentPhone}
              useStudentPhone={useStudentPhone}
              contactPreference={contactPreference}
              contactPreferenceOther={contactPreferenceOther}
              facebook={facebook}
              line={line}
              isSaved={isSaved}
              handleClose={this.handleClose}
              currentUser={currentUser}
              handleCheckboxChange={this.handleCheckboxChange}
              handleAutoCompleteChange={this.handleAutoCompleteChange}
              handleBlurInput={this.handleBlurInput}
              gradeLevel={gradeLevel}
              yearLevel={yearLevel}
              gpaEngBox={gpaEngBox}
              gpaThaiBox={gpaThaiBox}
              gpaMathsBox={gpaMathsBox}
              gpaPhysBox={gpaPhysBox}
              gpaChemBox={gpaChemBox}
              gpaBioBox={gpaBioBox}
              gpaGeoBox={gpaGeoBox}
              gpaHistBox={gpaHistBox}
              gpaLitBox={gpaLitBox}
              gpaSSBox={gpaSSBox}
              gpaPolBox={gpaPolBox}
              gpaEcoBox={gpaEcoBox}
              gpaArtBox={gpaArtBox}
              gpaFLBox={gpaFLBox}
              gpaOthersBox={gpaOthersBox}
              gpaEng={gpaEng}
              gpaThai={gpaThai}
              gpaMaths={gpaMaths}
              gpaPhys={gpaPhys}
              gpaChem={gpaChem}
              gpaBio={gpaBio}
              gpaGeo={gpaGeo}
              gpaHist={gpaHist}
              gpaLit={gpaLit}
              gpaSS={gpaSS}
              gpaPol={gpaPol}
              gpaEco={gpaEco}
              gpaArt={gpaArt}
              gpaFL={gpaFL}
              gpaOthersField={gpaOthersField}
              favSubjEngBox={favSubjEngBox}
              favSubjThaiBox={favSubjThaiBox}
              favSubjMathsBox={favSubjMathsBox}
              favSubjPhysBox={favSubjPhysBox}
              favSubjChemBox={favSubjChemBox}
              favSubjBioBox={favSubjBioBox}
              favSubjGeoBox={favSubjGeoBox}
              favSubjHistBox={favSubjHistBox}
              favSubjLitBox={favSubjLitBox}
              favSubjSSBox={favSubjSSBox}
              favSubjPolBox={favSubjPolBox}
              favSubjEcoBox={favSubjEcoBox}
              favSubjArtBox={favSubjArtBox}
              favSubjFLBox={favSubjFLBox}
              favSubjOthersBox={favSubjOthersBox}
              favSubjOthersBoxField={favSubjOthersBoxField}
              weakestSubjEngBox={weakestSubjEngBox}
              weakestSubjThaiBox={weakestSubjThaiBox}
              weakestSubjMathsBox={weakestSubjMathsBox}
              weakestSubjPhysBox={weakestSubjPhysBox}
              weakestSubjChemBox={weakestSubjChemBox}
              weakestSubjBioBox={weakestSubjBioBox}
              weakestSubjGeoBox={weakestSubjGeoBox}
              weakestSubjHistBox={weakestSubjHistBox}
              weakestSubjLitBox={weakestSubjLitBox}
              weakestSubjSSBox={weakestSubjSSBox}
              weakestSubjPolBox={weakestSubjPolBox}
              weakestSubjEcoBox={weakestSubjEcoBox}
              weakestSubjArtBox={weakestSubjArtBox}
              weakestSubjFLBox={weakestSubjFLBox}
              weakestSubjOthersBox={weakestSubjOthersBox}
              weakestSubjOthersBoxField={weakestSubjOthersBoxField}
              extExamSAT={extExamSAT}
              extExamGRE={extExamGRE}
              extExamIELTS={extExamIELTS}
              extExamTOEFL={extExamTOEFL}
              extExamGMAT={extExamGMAT}
              extExamOthers={extExamOthers}
              extExamOthersField={extExamOthersField}
              otherTCcourseSAT={otherTCcourseSAT}
              otherTCcourseGRE={otherTCcourseGRE}
              otherTCcourseIELTS={otherTCcourseIELTS}
              otherTCcourseTOEFL={otherTCcourseTOEFL}
              otherTCcourseGMAT={otherTCcourseGMAT}
              otherTCcourseEnglish={otherTCcourseEnglish}
              otherTCcourseThai={otherTCcourseThai}
              otherTCcourseMath={otherTCcourseMath}
              otherTCcoursePhysics={otherTCcoursePhysics}
              otherTCcourseBiology={otherTCcourseBiology}
              otherTCcourseChemistry={otherTCcourseChemistry}
              otherTCcourseGeography={otherTCcourseGeography}
              otherTCcourseHistory={otherTCcourseHistory}
              otherTCcourseLiterature={otherTCcourseLiterature}
              otherTCcourseSocialStudies={otherTCcourseSocialStudies}
              otherTCcoursePolitics={otherTCcoursePolitics}
              otherTCcourseEconomics={otherTCcourseEconomics}
              otherTCcourseArt={otherTCcourseArt}
              otherTCcourseForeignLanguage={otherTCcourseForeignLanguage}
              otherTCcourseOthers={otherTCcourseOthers}
              otherTCcourseOthersField={otherTCcourseOthersField}
              studyingAtEPA={studyingAtEPA}
              coursesTakenAtEpaSAT={coursesTakenAtEpaSAT}
              coursesTakenAtEpaGRE={coursesTakenAtEpaGRE}
              coursesTakenAtEpaIELTS={coursesTakenAtEpaIELTS}
              coursesTakenAtEpaTOEFL={coursesTakenAtEpaTOEFL}
              coursesTakenAtEpaGMAT={coursesTakenAtEpaGMAT}
              coursesTakenAtEpaEnglish={coursesTakenAtEpaEnglish}
              coursesTakenAtEpaThai={coursesTakenAtEpaThai}
              coursesTakenAtEpaMath={coursesTakenAtEpaMath}
              coursesTakenAtEpaPhysics={coursesTakenAtEpaPhysics}
              coursesTakenAtEpaBiology={coursesTakenAtEpaBiology}
              coursesTakenAtEpaGeography={coursesTakenAtEpaGeography}
              coursesTakenAtEpaChemistry={coursesTakenAtEpaChemistry}
              coursesTakenAtEpaHistory={coursesTakenAtEpaHistory}
              coursesTakenAtEpaLiterature={coursesTakenAtEpaLiterature}
              coursesTakenAtEpaSocialStudies={coursesTakenAtEpaSocialStudies}
              coursesTakenAtEpaPolitics={coursesTakenAtEpaPolitics}
              coursesTakenAtEpaEconomics={coursesTakenAtEpaEconomics}
              coursesTakenAtEpaArt={coursesTakenAtEpaArt}
              coursesTakenAtEpaForeignLanguage={coursesTakenAtEpaForeignLanguage}
              coursesTakenAtEpaOthers={coursesTakenAtEpaOthers}
              coursesTakenAtEpaOthersField={coursesTakenAtEpaOthersField}
              handleAutoCompleteStudyAreaChange={this.handleAutoCompleteStudyAreaChange}
              handleAutoCompleteStudyAreaSpecificChange={this.handleAutoCompleteStudyAreaSpecificChange}
              handleAutoCompleteStudyAreaChange1={this.handleAutoCompleteStudyAreaChange1}
              handleAutoCompleteStudyAreaSpecificChange1={this.handleAutoCompleteStudyAreaSpecificChange1}
              handleAutoCompleteStudyAreaChange2={this.handleAutoCompleteStudyAreaChange2}
              handleAutoCompleteStudyAreaSpecificChange2={this.handleAutoCompleteStudyAreaSpecificChange2}
              handleAutoCompleteStudyAreaChange3={this.handleAutoCompleteStudyAreaChange3}
              handleAutoCompleteStudyAreaSpecificChange3={this.handleAutoCompleteStudyAreaSpecificChange3}
              handleAutoCompleteStudyAreaChange4={this.handleAutoCompleteStudyAreaChange4}
              handleAutoCompleteStudyAreaSpecificChange4={this.handleAutoCompleteStudyAreaSpecificChange4}
              careerGoalsStudentPerspective={careerGoalsStudentPerspective}
              needConsultationForACC={needConsultationForACC}
              areaOfStudy={areaOfStudy}
              areaOfStudySpecific={areaOfStudySpecific}
              areaOfStudy1={areaOfStudy1}
              areaOfStudySpecific1={areaOfStudySpecific1}
              areaOfStudy2={areaOfStudy2}
              areaOfStudySpecific2={areaOfStudySpecific2}
              areaOfStudy3={areaOfStudy3}
              areaOfStudySpecific3={areaOfStudySpecific3}
              areaOfStudy4={areaOfStudy4}
              areaOfStudySpecific4={areaOfStudySpecific4}
              areaOfStudyOthers={areaOfStudyOthers}
              areaOfStudyOthersField={areaOfStudyOthersField}
              areaOfStudyUnsure={areaOfStudyUnsure}
              studyGoalsStudentPerspectiveEntranceExamBox={studyGoalsStudentPerspectiveEntranceExamBox}
              studyGoalsStudentPerspectiveEntranceExamField={studyGoalsStudentPerspectiveEntranceExamField}
              studyGoalsStudentPerspectiveSchoolExamBox={studyGoalsStudentPerspectiveSchoolExamBox}
              studyGoalsStudentPerspectiveSATBox={studyGoalsStudentPerspectiveSATBox}
              studyGoalsStudentPerspectiveGREBox={studyGoalsStudentPerspectiveGREBox}
              studyGoalsStudentPerspectiveIELTSBox={studyGoalsStudentPerspectiveIELTSBox}
              studyGoalsStudentPerspectiveTOEFLBox={studyGoalsStudentPerspectiveTOEFLBox}
              studyGoalsStudentPerspectiveGMATBox={studyGoalsStudentPerspectiveGMATBox}
              studyGoalsStudentPerspectiveOthersBox={studyGoalsStudentPerspectiveOthersBox}
              studyGoalsStudentPerspectiveOthersField={studyGoalsStudentPerspectiveOthersField}
              targetCountryStudentUS={targetCountryStudentUS}
              targetCountryStudentCanada={targetCountryStudentCanada}
              targetCountryStudentUK={targetCountryStudentUK}
              targetCountryStudentAustralia={targetCountryStudentAustralia}
              targetCountryStudentNewZealand={targetCountryStudentNewZealand}
              targetCountryStudentOthersBox={targetCountryStudentOthersBox}
              targetCountryStudentOthersField={targetCountryStudentOthersField}
              specialRequests={specialRequests}
              learningTypeVisual={learningTypeVisual}
              learningTypeKinaesthetic={learningTypeKinaesthetic}
              learningTypeAural={learningTypeAural}
              learningTypeSocial={learningTypeSocial}
              learningTypeSolitary={learningTypeSolitary}
              learningTypeVerbal={learningTypeVerbal}
              learningTypeLogical={learningTypeLogical}
              learningTypeUnsure={learningTypeUnsure}
              learningTypeOthersBox={learningTypeOthersBox}
              learningTypeOthersField={learningTypeOthersField}
              personalityTestCheck={personalityTestCheck}
              personalityTestResult={personalityTestResult}
              personalityTestResultField={personalityTestResultField}
              scDominanceDirect={scDominanceDirect}
              scDominanceResultsOriented={scDominanceResultsOriented}
              scDominanceFirm={scDominanceFirm}
              scDominanceStrongWilled={scDominanceStrongWilled}
              scDominanceForceful={scDominanceForceful}
              scInfluenceOutgoing={scInfluenceOutgoing}
              scInfluenceEnthusiastic={scInfluenceEnthusiastic}
              scInfluenceOptimistic={scInfluenceOptimistic}
              scInfluenceHighSpirited={scInfluenceHighSpirited}
              scInfluenceLively={scInfluenceLively}
              scConscientiousnessAnalytical={scConscientiousnessAnalytical}
              scConscientiousnessReserved={scConscientiousnessReserved}
              scConscientiousnessPrecise={scConscientiousnessPrecise}
              scConscientiousnessPrivate={scConscientiousnessPrivate}
              scConscientiousnessSystematic={scConscientiousnessSystematic}
              scSteadinessEvenTempered={scSteadinessEvenTempered}
              scSteadinessAccommodating={scSteadinessAccommodating}
              scSteadinessPatient={scSteadinessPatient}
              scSteadinessHumble={scSteadinessHumble}
              scSteadinessTactful={scSteadinessTactful}
              healthConditionNA={healthConditionNA}
              healthConditionADHD={healthConditionADHD}
              healthConditionAutism={healthConditionAutism}
              healthConditionOthersBox={healthConditionOthersBox}
              healthConditionOthersField={healthConditionOthersField}
              preferredTeacherStudentPerspectiveMale={preferredTeacherStudentPerspectiveMale}
              preferredTeacherStudentPerspectiveFemale={preferredTeacherStudentPerspectiveFemale}
              preferredTeacherStudentPerspectiveNameBox={preferredTeacherStudentPerspectiveNameBox}
              preferredTeacherStudentPerspectiveNameField={preferredTeacherStudentPerspectiveNameField}
              preferredTeacherStudentPerspectiveAuthority={preferredTeacherStudentPerspectiveAuthority}
              preferredTeacherStudentPerspectiveDelegator={preferredTeacherStudentPerspectiveDelegator}
              preferredTeacherStudentPerspectiveFacilitator={preferredTeacherStudentPerspectiveFacilitator}
              preferredTeacherStudentPerspectiveDemonstrator={preferredTeacherStudentPerspectiveDemonstrator}
              preferredTeacherStudentPerspectiveHybrid={preferredTeacherStudentPerspectiveHybrid}
              preferredTeacherStudentPerspectiveOthersBox={preferredTeacherStudentPerspectiveOthersBox}
              preferredTeacherStudentPerspectiveOthersField={preferredTeacherStudentPerspectiveOthersField}
              interestedTopicsPublicSpeaking={interestedTopicsPublicSpeaking}
              interestedTopicsDebate={interestedTopicsDebate}
              interestedTopicsCoding={interestedTopicsCoding}
              interestedTopicsLeadership={interestedTopicsLeadership}
              interestedTopicsWriting={interestedTopicsWriting}
              interestedTopicsCreativeWriting={interestedTopicsCreativeWriting}
              interestedTopicsFormalWriting={interestedTopicsFormalWriting}
              interestedTopicsReadingComprehension={interestedTopicsReadingComprehension}
              interestedTopicsLiterature={interestedTopicsLiterature}
              interestedTopicsOthersBox={interestedTopicsOthersBox}
              interestedTopicsOthersField={interestedTopicsOthersField}
            />
          </div>
        </div>
      </div>
    )
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Edit))
